import {
  Input,
  OriNumberInput,
  OriSelect,
  OriginalPicker,
  RadioGroup,
  RadioItem,
} from '@/src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Form } from 'src/components/Antd';
import { StyledTitle } from 'src/layout/EditorPageLayout/SectionTitle';
import {
  calendarName,
  periodName,
  redemptionCodeName,
  typeName,
  unitName,
} from 'src/pages/ProductEditor/VirtualProduct/EditorHOC';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionHOC from '../HOC';
import { EnumCollapseId } from '../slice';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const Item = Form.Item;
export enum EType {
  NoExpirationDate = 'NoExpirationDate',
  ExpireOnSpecificDate = 'ExpireOnSpecificDate',
  ExpireSpecificPeriod = 'ExpireSpecificPeriod',
}
export enum EUnit {
  Month = 'Month',
  Year = 'Year',
}
// const typeName = ['productGiftCardSetting', 'expirationDateSetting', 'type'];
// const calendarName = [
//   'productGiftCardSetting',
//   'expirationDateSetting',
//   'expirationDate',
// ];
// const periodName = [
//   'productGiftCardSetting',
//   'expirationDateSetting',
//   'expirationPeriod',
// ];
// const unitName = ['productGiftCardSetting', 'expirationDateSetting', 'unit'];
// const redemptionCodeName = ['productGiftCardSetting', 'redemptionCode'];

const CardSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  const disabledDate = (current) => {
    return current && current < moment().startOf('day');
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n(
            'allProducts.addvirtualproduct.giftCardSetting_general_expiration_title',
          )}>
          <Item
            rules={[
              {
                required: true,
                message: getI18n(
                  'allProducts.addvirtualproduct.giftCardSetting_general_rules',
                ),
              },
            ]}
            initialValue={EType.NoExpirationDate}
            name={typeName}>
            <RadioGroup className={css.radioGroup} disabled={disabled}>
              <RadioItem value={EType.NoExpirationDate} className={css.item}>
                {getI18n('allProducts.addvirtualproduct.noexpirationdate')}
              </RadioItem>
              <RadioItem
                className={css.item}
                value={EType.ExpireOnSpecificDate}>
                {getI18n(
                  'allProducts.addvirtualproduct.giftCardSetting_general_specific_date',
                )}
              </RadioItem>
              <RadioItem value={EType.ExpireSpecificPeriod}>
                {getI18n(
                  'allProducts.addvirtualproduct.giftCardSetting_general_specific_period',
                )}
              </RadioItem>
            </RadioGroup>
          </Item>
          <Item
            shouldUpdate={(p, c) => {
              const pV = get(p, typeName);
              const cV = get(c, typeName);
              return pV !== cV;
            }}>
            {({ getFieldValue }) => {
              const type = getFieldValue(typeName);
              if (type === EType.ExpireOnSpecificDate) {
                return (
                  <div className={css.calendarContainer}>
                    <Row
                      elements={[
                        {
                          child: (
                            <Item
                              name={calendarName}
                              rules={[
                                {
                                  required: true,
                                  message: getI18n(
                                    'allProducts.addvirtualproduct.giftCardSetting_general_rules',
                                  ),
                                },
                              ]}>
                              <OriginalPicker
                                disabled={disabled}
                                disabledDate={disabledDate}
                                size='large'
                                dateFormat={'YYYY-MM-DD'}
                              />
                            </Item>
                          ),
                        },
                        {
                          child: <React.Fragment />,
                        },
                      ]}
                    />
                  </div>
                );
              }
              if (type === EType.ExpireSpecificPeriod) {
                return (
                  <div className={css.periodContainer}>
                    <Item
                      className={css.periodInput}
                      name={periodName}
                      initialValue={12}
                      rules={[
                        {
                          required: true,
                          message: getI18n(
                            'allProducts.addvirtualproduct.giftCardSetting_general_rules',
                          ),
                        },
                      ]}>
                      <OriNumberInput
                        min={1}
                        size='large'
                        max={99999}
                        disabled={disabled}
                      />
                    </Item>
                    <Item
                      initialValue={EUnit.Month}
                      className={css.periodUnitInput}
                      name={unitName}
                      rules={[
                        {
                          required: true,
                          message: getI18n(
                            'allProducts.addvirtualproduct.giftCardSetting_general_rules',
                          ),
                        },
                      ]}>
                      <OriSelect size='large' disabled={disabled}>
                        <OriSelect.Option value={EUnit.Month}>
                          {getI18n('general.month(s)')}
                        </OriSelect.Option>
                        <OriSelect.Option value={EUnit.Year}>
                          {getI18n('general.year(s)')}
                        </OriSelect.Option>
                      </OriSelect>
                    </Item>
                    <div className={css.tip}>
                      {getI18n(
                        'allProducts.addvirtualproduct.giftCardSetting_general_after_purchase',
                      )}
                    </div>
                  </div>
                );
              }
              return null;
            }}
          </Item>
        </ItemWrapper>
      </Section>
      <Section>
        <ItemWrapper
          title={`${getI18n('allProducts.addvirtualproduct.redemptionCode')}*`}
          rightSubTitle={getI18n('allProducts.addvirtualproduct.48characters')}>
          <div className={css.inputContainer}>
            <Input
              //  className={css.input}
              size='large'
              disabled={disabled}
              formProps={{
                className: css.input,
                name: redemptionCodeName,
                rules: [
                  {
                    validator: async (x, value) => {
                      const len = (value || '').length;
                      if (len < 4 || len > 8) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'allProducts.addvirtualproduct.giftCardSetting_general_error',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ],
              }}
            />
            <div className={css.redemptionTip}>
              + {getI18n('allProducts.addvirtualproduct.8randomnumbers')}
            </div>
          </div>
          <div className={css.redemptionBottomTip}>
            <Icon type='iconinfo2' className={css.infoIcon} />
            {getI18n(
              'allProducts.addvirtualproduct.giftCardSetting_general_pin_content',
            )}
          </div>
        </ItemWrapper>
      </Section>
    </React.Fragment>
  );
};

export default SectionHOC(CardSetting, {
  id: EnumCollapseId.GiftCardSetting,
  title: (
    <StyledTitle
      left={getI18nFromGeneral('general.hOCTitle.giftCardSettings')}
    />
  ),

  useCustomCollapseTitle: true,
  useDefaultCollapseContent: false,
});
